/// <reference types="node" />

module.exports = (globalThis as any).React;
